import { render, staticRenderFns } from "./LevelDecrementsTable.vue?vue&type=template&id=b16f39fe&scoped=true&"
import script from "./LevelDecrementsTable.vue?vue&type=script&lang=js&"
export * from "./LevelDecrementsTable.vue?vue&type=script&lang=js&"
import style0 from "./LevelDecrementsTable.vue?vue&type=style&index=0&id=b16f39fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16f39fe",
  null
  
)

export default component.exports